export interface IShellInitialDataReader {
  /** The dashboard's address; throws when the page carries none, or one that is not a valid URL. */
  readDashboardAppUrl(): string;
}

/**
 * Reads the settings naru-server puts in the landing page (`window.__initial_data__`). This is where untyped page data
 * enters the app, so every value is checked here and nothing below sees `unknown`.
 */
export class ShellInitialDataReader implements IShellInitialDataReader {
  /** @param pageGlobals The page's global object (`window` in the browser). */
  constructor(private readonly pageGlobals: object) {}

  readDashboardAppUrl(): string {
    const initialData = this.readInitialData();

    if (!('dashboardAppUrl' in initialData) || typeof initialData.dashboardAppUrl !== 'string' || !URL.canParse(initialData.dashboardAppUrl)) {
      throw new Error('The landing page carries no valid dashboardAppUrl in its initial data');
    }

    return initialData.dashboardAppUrl;
  }

  private readInitialData(): object {
    const pageGlobals = this.pageGlobals;

    if (!('__initial_data__' in pageGlobals) || typeof pageGlobals.__initial_data__ !== 'object' || pageGlobals.__initial_data__ === null) {
      throw new Error('The landing page carries no initial data');
    }

    return pageGlobals.__initial_data__;
  }
}
